const MAX_UPDATE_TIME = 5 * 60 * 1000;

export const getTimeToFetch = (timestamps: string[]) => {
  const dateNow = Date.now();

  const minTime = Math.min(
    ...timestamps.map((timestamp) => Date.parse(timestamp) - dateNow).filter((time) => time > 0),
  );

  return minTime < MAX_UPDATE_TIME ? minTime : MAX_UPDATE_TIME;
};
